<template>
<div class="addHzDw">
  <div class="topss">
<!--    <el-select style="margin-right: 20px;" v-model="shop" filterable class="xza"  size="small" placeholder="请选择单位类型">-->
<!--      <el-option-->
<!--          v-for="item in zrdwArr"-->
<!--          :key="item.value"-->
<!--          :label="item.label"-->
<!--          :value="item.value">-->
<!--      </el-option>-->
<!--    </el-select>-->
<!--    <p>请选择单位：</p>-->
<!--    <el-select style="margin-right: 20px;" v-model="shop" @change="gezzList" filterable class="xza"  size="small" placeholder="请选择">-->
<!--      <el-option-->
<!--          v-for="item in zrdwArr"-->
<!--          :key="item.value"-->
<!--          :label="item.label"-->
<!--          :value="item.value">-->
<!--      </el-option>-->
<!--    </el-select>-->
    <p>顾客姓名：</p>
    <el-input v-model="namess" style="width: 200px;margin-right: 20px;" placeholder="请输入内容"></el-input>
    <p>顾客电话：</p>
    <el-input v-model="tel" style="width: 200px;margin-right: 20px;" placeholder="请输入内容"></el-input>
    <el-button type="primary" size="small">搜索</el-button>
    <el-button type="primary" @click="showzzd = true" size="small">添加转诊</el-button>
  </div>
  <ul class="bt">
    <li>转诊编号</li>
    <li>转入单位名称</li>
    <li>转入单位性质</li>
    <li>转入单位合作类型</li>
    <li>转诊创建时间</li>
    <li>转出时间</li>
    <li>转入时间</li>
    <li>转出备注</li>
    <li>打印</li>
  </ul>

  <div>
    <ul class="nrs" v-for="item in zzList">
      <li>{{item.ReferralId.slice(0,8)}}</li>
      <li>{{item.CreateCompanyName}}</li>
      <li>{{item.CC_Type}}</li>
      <li>{{item.ReferralGroupName }}</li>
      <li>{{item.ReferralAddTime }}</li>
      <li>{{item.TaskStartTime}}</li>
      <li>{{item.OppointmentTime}}</li>
      <li>{{item.ReferralRemark}}</li>
      <li><el-button size="mini" @click="dy(item.ReferralId)" plain>打印</el-button></li>
    </ul>
  </div>



  <el-dialog
      title="转诊单"
      :visible.sync="showzzd"
      width="750px"
  >
    <ZZD v-if="showzzd" @sxgb="tjcg"></ZZD>
  </el-dialog>

  <el-dialog
      title="转诊单"
      :visible.sync="showdy"
      width="750px"
  >
    <DYZZD v-if="showdy" :ids="dqzzid"></DYZZD>
  </el-dialog>
</div>
</template>

<script>
import { getzzlb} from "./api";

export default {
  name: "addHzDw",
  data() {
    return {
      shop: '',
      zrdwArr: [],
      zrdwAllArr: [],
      showzzd: false,
      zzList: [],
      namess: '',
      tel: '',
      showdy: false,
      dqzzid: ''
    }
  },
  created() {
    this.gezzList()
  },
  methods: {
    gezzList(e) {
      let log = this.$loading({text: '加载中...'})
      getzzlb(this.namess, this.tel)
          .then(res => {
            log.close()
            if (res.Result && res.Result.length) {
              this.zzList = [...res.Result]
            }
          })
    },
    tjcg() {
      this.showzzd = false
      this.gezzList()
    },
    dy(id) {
      this.dqzzid = id
      this.showdy = true
    }
  },
  components: {
    ZZD: () => import('./zzd'),
    DYZZD: () => import('./dyzzd')
  }
}
</script>

<style scoped lang="scss">
.topss {
  padding: 20px;
  display: flex;
  align-items: center;
}
.bt {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #0a0a0a;
  color: #FFFFFF;
  padding: 5px 0;
  li {
    width: calc(12.5% - 8px);
  }
  li:nth-child(1) {width: 80px;}
  li:nth-child(9) {width: 70px;}
}
.nrs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 0;
  border-bottom: 1px solid #7f7e7e;
  li {
    width: calc(12.5% - 8px);
  }
  li:nth-child(1) {width: 80px;}
  li:nth-child(9) {width: 70px;}
}
</style>
